<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Calendar Periods" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="settings" pageId="calendar-period-review" color="white"></help-link>
                    <v-menu v-if="hasEditAndApproverRights" left v-model="menu_status" offset-y> 
                        <template v-slot:activator="{ on }">
                            <v-btn v-show="forReview_status" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;For Review&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="approved_status" color="green darken-2"  dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Approved&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="rejected_status" color="red"  dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Rejected&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="cutoffPeriodAllClosed" v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Closed&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <!-- disabled since calendar start/end dates are based on cutoff settings and are readonly in popup -->
                            <!-- <v-list-tile v-show="hasEditAndApproverRights&&!hasPayrollGenerated&&!hasFrozenPeriod&&(forReview_status||rejected_status)" :key="0" @click="showEdit" title="Edit Calendar Period">
                                <v-list-tile-title small>Edit</v-list-tile-title>
                            </v-list-tile> -->
                            <v-list-tile v-show="(forReview_status||rejected_status)&&!cutoffPeriodAllClosed" :key="1" @click="approve" title="Approve Calendar Period">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="(forReview_status||approved_status)&&!cutoffPeriodAllClosed" :key="2" @click="reject" title="Reject Calendar Period">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="approved_status&&cutoffPeriodAllClosed" :key="3" @click="closeFiscalPeriod" title="Close Calendar Period">
                                <v-list-tile-title small>Close</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-menu v-if="!hasEditAndApproverRights&&(hasEditRights||hasApproverRights)" left v-model="menu_status" offset-y :disabled="disabledEdit"> 
                        <template v-slot:activator="{ on }">
                            <v-btn v-show="forReview_status" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;For Review&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="approved_status" color="green darken-2"  dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Approved&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="rejected_status" color="red"  dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Rejected&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="cutoffPeriodAllClosed" v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Closed&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <!-- disabled since calendar start/end dates are based on cutoff settings and are readonly in popup -->
                            <!-- <v-list-tile v-show="hasEditRights&&!hasPayrollGenerated&&!hasFrozenPeriod&&(forReview_status||rejected_status)" :key="0" @click="showEdit" title="Edit Calendar Period">
                                <v-list-tile-title small>Edit</v-list-tile-title>
                            </v-list-tile> -->
                            <v-list-tile  v-show="hasApproverRights&&(forReview_status||rejected_status)&&!cutoffPeriodAllClosed" :key="1" @click="approve" title="Approve Calendar Period">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReview_status||approved_status)&&!cutoffPeriodAllClosed" :key="2" @click="reject" title="Reject Calendar Period">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&approved_status&&cutoffPeriodAllClosed" :key="3" @click="closeFiscalPeriod" title="Close Calendar Period">
                                <v-list-tile-title small>Close</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>
            
            <v-expansion-panel v-model="panel" expand class="mt-5">
                <!-- Calendar year -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-7px;':''">CALENDAR YEAR</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elevation-1 transparent"> 
                        <v-card-text v-if="!loading" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Calendar Year :
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{fiscal_period.fiscalYear}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Calendar Start Date : 
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{fiscal_period.fiscalStartDate|moment('MMMM D, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Calendar End Date : 
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{fiscal_period.fiscalEndDate|moment('MMMM D, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Calendar Period Status :
                                        </v-flex>
                                        <v-flex xs7 class="text-xs-left">
                                            <b :class="commonfn.getStatusColor(fiscal_period.fiscalPeriodStatus)">{{commonfn.getStatusDescription(fiscal_period.fiscalPeriodStatus)}}</b>
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs5 class="text-xs-left">
                                            Cutoff frequency :
                                        </v-flex>
                                        <v-flex xs7 class="font-weight-bold text-xs-left">
                                            {{fiscal_period.cutoffFrequency}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                
                <!-- Cutoff periods -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold primary--text" :style="isMobile?'margin-left:-7px;':''">CUTOFF PERIODS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-data-table
                        :headers="headers"
                        :items="fiscal_period.cutoffPeriods"
                        :rows-per-page-items="rowsPerPageItems"
                        :pagination.sync="paginationSync"
                    >
                        <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                        <template v-slot:items="props">
                            <tr :title="!forReview_status && !rejected_status?'Click to view cutoff detail':''" @click="viewCutoffDetail(props.item)" class="clickable"> 
                                <td>{{ props.item.cutoffStart | moment("MMM D, YYYY") }}</td>
                                <td>{{ props.item.cutoffEnd | moment("MMM D, YYYY") }}</td>
                                <td>
                                    <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                </td>
                            </tr>
                        </template>
                    </v-data-table> 
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="fiscalPeriodId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogAddEdit" persistent width="500">
            <add-edit ref="addEditRef" :dialogAddEdit.sync="dialogAddEdit" @send="getFiscalPeriod(false)"></add-edit>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="fiscalPeriodId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import commonfn from '@/common/functions'   //for refactor
import fiscalPeriodsApi from '@/api/fiscalperiods'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import rowsPerPageItems from '@/constants/rows-per-page'
import { hasEditRights, hasApproverRights } from '@/helpers/access-permissions'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'

export default {     
    name: 'CalendarPeriodDetails',
    metaInfo: {
        title: 'Calendar Period Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Calendar Period Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'add-edit' : () => import('@/components/FiscalPeriods/FiscalPeriodAddEdit'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            message: null,
            menu_status: false,
            loading_status: false,
            headers: [
                {text: 'Start Date',align: 'left',value: 'cutoffStart', width: '25%', sortable:true},
                {text: 'End Date',align: 'left',value: 'cutoffEnd', width: '25%', sortable:true},
                {text: 'Status',align: 'left',value: 'status', width: '25%', sortable:true},
            ],
            loading: false,
            loading_delete: false,
            panel: [true,true],
            dialogAddEdit: false,
            fiscal_period: {},
        }
    },
    methods: {
        viewCutoffDetail(data) {
            if (!this.forReview_status && !this.rejected_status) {
                this.$router.push(`${this.$router.currentRoute.path}/${data.cutoffId}`)
            }
        },
        async closeFiscalPeriod() {
            try {
                this.loading_status = true
                var data = {
                    fiscalPeriodId: this.fiscalPeriodId
                }
                await fiscalPeriodsApi.close(data) 
                this.getFiscalPeriod(false)
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    fiscalPeriodId: this.fiscalPeriodId
                }
                await fiscalPeriodsApi.approve(data) 
                this.getFiscalPeriod(false)
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    fiscalPeriodId: this.fiscalPeriodId
                }
                await fiscalPeriodsApi.reject(data) 
                this.getFiscalPeriod(false)
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        showEdit() {
            this.$refs.addEditRef.setUpdate(this.fiscal_period)
            this.dialogAddEdit = true
        },
        async getFiscalPeriod(display_loading) {
            try {
                if (display_loading) this.loading = true
                const response = await fiscalPeriodsApi.getFiscalPeriod(this.fiscalPeriodId) 
                if (response && response.status==200) {
                    this.fiscal_period = response.data
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getFiscalPeriod(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        await this.getFiscalPeriod(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.selectedFiscalYear} Calendar Period`
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        fiscalPeriodId() {
            return this.$route.params.fiscalPeroidId
        },
        hasEditAndApproverRights() {
            return this.hasEditRights && this.hasApproverRights
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        commentsData() {
            if (this.fiscal_period) {
                return {
                    pageQueryId: this.fiscalPeriodId,
                    pageItemCreatedBy: this.fiscal_period.createdBy,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.fiscal_periods,
                    notificationTypeId: notificationTypes.fiscal_periods
                }
            }
        },
        page_title_class() {
            if (this.isMobile) return 'margin:18px 0px 0px 22px;'
            else return 'margin:5px 0px 0px 30px;'
        },
        selectedFiscalYear() {
            if (this.fiscal_period)
                return this.fiscal_period.fiscalYear
        },
        forReview_status() {
            if (this.fiscal_period)
                return this.fiscal_period.recordStatus==commonfn.getStatusCode('For Review')
        },
        approved_status() {
            if (this.fiscal_period)
                return this.fiscal_period.recordStatus==commonfn.getStatusCode('Approved')
        },
        rejected_status() {
            if (this.fiscal_period)
                return this.fiscal_period.recordStatus==commonfn.getStatusCode('Rejected')
        },
        closed_status() {
            if (this.fiscal_period)
                return this.fiscal_period.recordStatus==commonfn.getStatusCode('Closed')
        },
        hasPayrollGenerated() {
            if (!this.loading && this.fiscal_period) {
                return this.fiscal_period.cutoffPeriods.filter(x => x.payrollGeneratedCount > 0).length > 0
            }
        },    
        hasFrozenPeriod() {
            if (!this.loading && this.fiscal_period) {
                return this.fiscal_period.cutoffPeriods.filter(x => x.status ==commonfn.getStatusCode('Frozen')).length > 0
            }
        }, 
        cutoffPeriodAllClosed() {
            if (!this.loading) {
                var closed = this.fiscal_period.cutoffPeriods.filter(x => {
                    return x.status == commonfn.getStatusCode('Closed')
                })
                return this.fiscal_period.cutoffPeriods.length==closed.length
            }
        },
        disabledEdit() {
            return this.hasEditRights&&(this.forReview_status||this.closed_status||(this.approved_status&&!this.cutoffPeriodAllClosed))
        }
    }
}
</script>
<style scoped>
.section-layout {
    padding:0px 20px 0px 50px;
}
.section-layout-mobile {
    padding:0px 10px 0px 10px;
}
</style>